const Footer = () => {
    return <div className="dark:text-white-dark text-center ltr:sm:text-left rtl:sm:text-right p-6 pt-0 mt-auto">© All Rights Reserved By Sharepal.</div>;
};

export default Footer;
